import React from 'react'
import '../../node_modules/bootstrap/dist/css/bootstrap.css'
import '../assets/fontawesome/all.css'
import AboutMe from '../pages/aboutMe/AboutMe'
import Resume from '../pages/resume/Resume'
import Portfolio from '../pages/portfolio/Portfolio'
import Blog from '../pages/blog/Blog'
import ContactUs from '../pages/contactUs/ContactUs'
import $ from 'jquery';
import { useSelector } from 'react-redux'
import { selectContactUsInfo } from '../reducers/resumeSlice'
import SideBar from './SideBar'


export default function EnLayout() {
    const contactUsInfo = useSelector(selectContactUsInfo)
    // console.log(contactUsInfo);
    function menuToggleFuncDarck() {
        $('.menu-toggle').toggleClass('open');
        $('.menu-toggle-darck').toggleClass('menu-toggle-darck-active');
        $('.header').toggleClass('header-mob-show');
        console.log("dark");
    }


    return (
        <>
            <div className="content-page position-relative h-100">
                <div className="lm-animated-bg"></div>
                <div className="container h-100">
                    {/* <!-- <div className="half-bg"></div> --> */}
                    <div className="content-page-in">
                        <div className="row h-100">
                            <div className="col-xl-3 col-lg-4 ps-0 mb-3 mb-lg-0">
                                <SideBar contactUsInfo={contactUsInfo} />
                            </div>
                            <div className="col-xl-9 col-lg-8 pe-lg-0">
                                <div className="content-area">
                                    {/* <!-- start animated-sections --> */}
                                    <div className="animated-sections">

                                        {/* start #about-me */}
                                        <AboutMe />
                                        {/* end #about-me  */}

                                        {/* start #resume */}
                                        <Resume />
                                        {/* end #resume */}

                                        {/* start portfolio */}
                                        <Portfolio />
                                        {/* end portfolio  */}

                                        {/* start blog  */}
                                        <Blog />
                                        {/* <!-- end blog --> */}

                                        {/* <!-- start contact --> */}
                                        <ContactUs />
                                        {/* <!-- end contact --> */}

                                    </div>
                                    {/* <!-- end animated-sections --> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="menu-toggle-darck" onClick={() => menuToggleFuncDarck()}></div>
        </>
    )
}
